import {ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy, OnInit} from '@angular/core'
import {TranslocoService} from '@ngneat/transloco'
import {faComment} from '@fortawesome/pro-solid-svg-icons/faComment'
import {faPhone} from '@fortawesome/pro-solid-svg-icons/faPhone'
import {PUBLIC_ROUTES} from '../../../routing/public.routes'
import {Subject, zip} from 'rxjs'
import {OTHER_OFFERING_ID} from '../../../../core/i18n/link.service'
import {ApplicationRoute} from '../../../../craft/utils/application.route'
import {map} from 'rxjs/operators'
import type {CallToAction} from '../../../../core/content/types/call-to-action.types'

@Component({
  selector: 'bgo-sticky-bottom-navigation',
  templateUrl: './sticky-bottom-navigation.component.html',
  styleUrls: ['./sticky-bottom-navigation.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StickyBottomNavigationComponent implements OnInit, OnChanges, OnDestroy {
  @Input() offeringId?: string
  @Input() guaranteeText?: string
  @Input() mainCta?: CallToAction

  private readonly unsubscribe$ = new Subject<true>()
  protected readonly phoneIcon = faPhone
  protected readonly contactIcon = faComment

  protected readonly benefits$ = zip(
    this.transloco.selectTranslate('jobRequestBottomNavigation.benefit1'),
    this.transloco.selectTranslate('jobRequestBottomNavigation.benefit2'),
    this.transloco.selectTranslate('jobRequestBottomNavigation.benefit3'),
  ).pipe(map(([benefit1, benefit2, benefit3]) => [benefit1, benefit2, benefit3] as string[]))

  // CTA shown in case none is configured in the CMS or if it's not of type 'Path'
  protected defaultCta!: CallToAction
  constructor(private readonly transloco: TranslocoService) {}

  ngOnInit(): void {
    this.defaultCta = {
      label: this.transloco.translate('jobRequestBottomNavigation.jobRequestCta'),
      type: 'Path',
      value: new ApplicationRoute(
        PUBLIC_ROUTES.JOB_REQUEST.path.replace(':offeringId', this.offeringId || OTHER_OFFERING_ID),
      ),
    }
  }

  ngOnChanges(): void {
    this.ngOnInit()
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true)
    this.unsubscribe$.complete()
  }

  getCallToAction(): CallToAction {
    if (this.mainCta) {
      return this.mainCta
    }
    return this.defaultCta
  }
}
